export default __webpack_public_path__ + "static/media/landing_page_reference_2.4daa7c53.jpg";